module.exports = __webpack_public_path__ + "img/background_principal_pc1450.be196be3.webp";